<!--

 -->

<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="show"
      class="gsl-hrm-dialog-popup"
      @update:show="onCancel"
    >
      <div class="gsl-hrm-modal-header">
        <oxd-text type="card-title">
          {{ $t('leave.leave_action', {action: action}) }}
        </oxd-text>
      </div>

      <div v-if="content?.length > 0" class="gsl-hrm-text-left-align">
        <oxd-text type="card-body">
          {{ $t('leave.leave_approval_confirmation_subtitle') }}
        </oxd-text>
        <br />
        <oxd-text
          v-for="(name, index) in content"
          :key="index"
          type="card-body"
        >
          {{ name }}
        </oxd-text>
        <br />
      </div>

      <div class="gsl-hrm-text-left-align">
        <oxd-text type="card-body">
          {{
            $t('leave.bulk_leave_action_confirm_message_one', {
              action: action,
              count: count,
            })
          }}
          {{ $t('leave.bulk_leave_action_confirm_message_two') }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-modal-footer">
        <oxd-button
          :label="$t('general.no_cancel')"
          display-type="text"
          class="gsl-hrm-button-margin"
          @click="onCancel"
        />
        <oxd-button
          :label="$t('leave.yes_confirm')"
          display-type="secondary"
          @click="onConfirm"
        />
      </div>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';

export default {
  name: 'LeaveBulkActionModal',
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      reject: null,
      resolve: null,
    };
  },
  computed: {
    count() {
      return this.data?.count ? this.data.count : 0;
    },
    action() {
      return this.data?.action;
    },
    content() {
      return this.data?.content;
    },
  },
  methods: {
    showDialog() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.show = true;
      });
    },
    onCancel() {
      this.show = false;
      this.resolve && this.resolve('cancel');
    },
    onConfirm() {
      this.show = false;
      this.resolve && this.resolve('ok');
    },
  },
};
</script>

<style scoped>
.gsl-hrm-modal-header {
  margin-bottom: 1.2rem;
  display: flex;
  justify-content: center;
}
.gsl-hrm-modal-footer {
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
}
.gsl-hrm-button-margin {
  margin: 0.25rem;
}
.gsl-hrm-text-center-align {
  text-align: center;
}
.gsl-hrm-text-left-align {
  text-align: left;
}
</style>
